module.exports = "/_next/static/images/burger_takeout-b97eca8880bfecf11267853be49d64a9.jpg";